import dayjs from "dayjs";

import { TextCell, shortMonthDayAndYear, shortMonthAndYearWithDelimiter } from "@similarweb/pro-logic-components";
import type { ColumnsType } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";
import { numberFilter } from "app/filters/numberFilter";

import { renderAdvertiserCell, renderLandingPageLinkCell } from "../../../utils/campaignColumnCells";
import { isDailyGranularityLocked } from "../../../utils/utils";

import type { IIndustryCampaignRow } from "./useIndustryTopCampaigns";

export const getColumns = (onAdvertiserClick: (domain: string) => void): ColumnsType<IIndustryCampaignRow> =>
    [
        {
            title: () => (
                <TextCell
                    fontVariant="captionTitle"
                    color={colorsPalettes.carbon[300]}
                >
                    {translate("ad.intelligence.advertiser.top.campaigns.campaigns.column.title")}
                </TextCell>
            ),
            dataIndex: "campaignName",
            render: (name: string) => <TextCell>{name}</TextCell>,
        },
        {
            title: translate("ad.intelligence.advertiser.campaigns.landingPageLink.column.title"),
            dataIndex: "landingPageLink",
            render: renderLandingPageLinkCell,
        },
        {
            title: translate("ad.intelligence.ads.table.advertiser.title"),
            dataIndex: "advertiser",
            render: (advertiser: string) => renderAdvertiserCell(advertiser, onAdvertiserClick),
        },
        {
            title: translate("ad.intelligence.advertiser.campaigns.creatives.column.title"),
            dataIndex: "creativesCount",
            align: "right",
            render: (creativesCount: number) => <TextCell>{numberFilter()(creativesCount)}</TextCell>,
        },
        ...(!isDailyGranularityLocked()
            ? [
                  {
                      title: translate("ad.intelligence.advertiser.campaigns.active.days.column.title"),
                      dataIndex: "activeDays",
                      align: "left" as const,
                      render: (activeDays: number) =>
                          `${numberFilter()(activeDays)} ${translate(
                              activeDays > 1
                                  ? "ad.intelligence.advertiser.campaigns.active.days.column.days"
                                  : "ad.intelligence.advertiser.campaigns.active.days.column.day",
                          )}`,
                  },
              ]
            : []),
        {
            title: translate("ad.intelligence.advertiser.campaigns.first.seen.column.title"),
            dataIndex: "firstSeen",
            align: "left",
            render: (firstSeen: string) =>
                dayjs(firstSeen).format(
                    isDailyGranularityLocked() ? shortMonthAndYearWithDelimiter : shortMonthDayAndYear,
                ),
        },
        {
            title: translate("ad.intelligence.advertiser.campaigns.last.seen.column.title"),
            dataIndex: "lastSeen",
            align: "left",
            render: (lastSeen: string) =>
                dayjs(lastSeen).format(
                    isDailyGranularityLocked() ? shortMonthAndYearWithDelimiter : shortMonthDayAndYear,
                ),
        },
    ] as ColumnsType<IIndustryCampaignRow>;
